module.exports = __webpack_public_path__ + "static/media/ICONS-APPAREL.61a1721b.svg";